import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import APIS from "./utils/APIS"

import "@fontsource/plus-jakarta-sans" //regular 400
import "@fontsource/plus-jakarta-sans/500.css" //medium 500
import "@fontsource/plus-jakarta-sans/500-italic.css" //medium 500 italic
import "@fontsource/plus-jakarta-sans/600.css" //semibold 600
import "@fontsource/plus-jakarta-sans/700.css" //bold 700


ReactDOM.render(
  (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ),
  document.getElementById('root')
);
